import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentSpace } from "../_components";
import { Selectors } from "../_reducers/app.reducer";
import { parkingActions } from "../_actions";
import { ParkingListView } from "./ParkingListView";
import { ParkingSpotConfigView } from "./ParkingSpotConfigView";

export function ParkingModule() {
    const dispatch = useDispatch();

    const locationInfo = useSelector(Selectors.getLocationInfo);
    const selectedSpot = useSelector(Selectors.getSelectedParkingSpot);
    const locationUid = useSelector(Selectors.getSelectedLocationUid);

    useEffect(() => {
        return () => {
            dispatch(parkingActions.selectSpot(null));
        };
    }, [dispatch]);

    return (
        <ContentSpace
            mainContent={<ParkingListView />}
            detailedContent={selectedSpot ? <ParkingSpotConfigView /> : null}
            onGoBack={() => dispatch(parkingActions.selectSpot(null))}
        />
    );
}
